import React, {useEffect} from 'react';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import withIsConnected from '../../hoc/withIsConnected';
import Localized from 'src/constants/AppStrings';
import {IsConnectedProps} from 'src/types/Screen';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import BaseScreen from 'src/components/screens/BaseScreen';
import ScanAndPayLocationsList from 'src/components/elements/home/ScanAndPayLocationsList';
import {CampusLocationType} from 'src/types/CampusLocationTypes';
import AVText from 'src/components/elements/AVText';
import {StyleSheet} from 'react-native';
import Styles from 'src/components/Styles';
import {getDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

type ChooseLocationScreenProps = {
  locations: CampusLocationType[];
  coffeeLocations: CampusLocationType[];
  onLocationClick: (machine, autoAdvanced?: boolean) => Promise<void>;
  isUnSupportedLocation?: boolean;
} & IsConnectedProps;

const {subHeaderContainerStyleDescriptor, bodyFontSize} = getLayoutDescriber();

const ChooseLocationScreen = (props: ChooseLocationScreenProps) => {
  useEffect(() => {
    FirebaseAnalytic.trackEvent('componentDidMount', 'ChooseLocationScreen', {
      ...props,
    });
  }, []);

  return (
    <BaseScreen
      title={Localized.Labels.choose_a_location}
      accessibilityLabel={'Back arrow'}
      accessibilityHint={`Press to navigate back to the Home screen`}
    >
      <AVText
        style={[
          styles.instructionTextTitle,
          getDescriber()?.snackDetailsBtnFontSTyle(),
        ]}
      >
        {`${Localized.Labels.instructions}: `}
        <AVText style={styles.instructionText}>
          {Localized.Labels.start_by_choosing_a_market_description}
        </AVText>
      </AVText>
      <AVText
        style={[
          styles.instructionSectionHeader,
          getDescriber()?.snackDetailsBtnFontSTyle(),
          subHeaderContainerStyleDescriptor().subHeaderTextStyle,
        ]}
      >
        {Localized.Labels.markets}
      </AVText>
      <ScanAndPayLocationsList
        locations={props.locations}
        isConnected={true}
        onLocationClick={props.onLocationClick}
        scrollEnabled={true}
        coffeeLocations={props.coffeeLocations}
        isUnSupportedLocation={props.isUnSupportedLocation}
      />
    </BaseScreen>
  );
};

export default withForwardedNavigationParams()(
  withIsConnected(ChooseLocationScreen),
);

const styles = StyleSheet.create({
  instructionTextTitle: {
    fontWeight: '700',
    fontSize: bodyFontSize(),
    color: Styles.black,
    marginHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
    marginTop: Styles.Spacing.m3,
  },
  instructionSectionHeader: {
    color: Styles.black,
    marginHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
    marginTop: Styles.Spacing.m3,
  },
  instructionText: {
    fontWeight: '400',
  },
});
